import React from 'react';
import addIfMissingComponent from '../util/addIfMissingComponent';

const Footer = ({children}) => (<>{addIfMissingComponent(children, "FooterComponent")}</>);

export default Footer;
